import fetchWebApi from 'api/fetchWebApi';

const postTinkConsentApiCall = async (): Promise<void> => {
  fetchWebApi(
    '/client/consent/tink',
    { consented: true },
    {
      method: 'post',
    },
  );
};

export default postTinkConsentApiCall;
